import React from 'react';

import { CORPORATE_EMAIL_ADDRESS } from '@utils/constants';

const Contact = () => {
  return (
    <p className="my-28 border border-x-0 border-solid border-grayscale-beige py-16 font-suisse-intl text-button-sm">
      To add additional seats to your license, please contact{' '}
      <a
        href="mailto:corporate@theinformation.com"
        className="underline hover:text-primary-magenta dark:hover:text-primary-pink"
      >
        {CORPORATE_EMAIL_ADDRESS}
      </a>
      .
    </p>
  );
};

export default Contact;
